import { render } from "./DeleteReasonDialog.vue?vue&type=template&id=3619ab1f&scoped=true&ts=true"
import script from "./DeleteReasonDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteReasonDialog.vue?vue&type=script&lang=ts"

import "./DeleteReasonDialog.vue?vue&type=style&index=0&id=3619ab1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3619ab1f"]])

export default __exports__